(ns storrito.ui.spinner)

(defn vire-spinner-xs
  ([] (vire-spinner-xs {}))
  ([params]
   [:div.flex.justify-center.items-center
    params
    [:div.animate-spin.rounded-full.h-4.w-4.border-b-2.border-professional-400]]))

(defn button-spinner-overlay
  []
  [:div.absolute.left-0.top-0.w-full.h-full.htmx-indicator
   (vire-spinner-xs)])

(defn vire-spinner-sm
  ([] (vire-spinner-sm {}))
  ([params] [:div.flex.justify-center.items-center
             params
             [:div.animate-spin.rounded-full.h-6.w-6.border-b-2.border-professional-400]]))

(defn vire-spinner-md
  ([] (vire-spinner-md {}))
  ([params] [:div.flex.justify-center.items-center
             params
             [:div.animate-spin.rounded-full.h-12.w-12.border-b-2.border-professional-400]]))

(defn vire-spinner-lg []
  [:div.flex.justify-center.items-center
   [:div.animate-spin.rounded-full.h-48.w-48.border-b-2.border-professional-400]])

(defn vire-spinner-xl []
  [:div.flex.justify-center.items-center
   [:div.animate-spin.rounded-full.h-64.w-64.border-b-2.border-professional-400]])

(defn primary-spinner
  []
  [:div.flex.items-center.justify-center
   [:svg.animate-spin.h-12.w-12.text-primary
    {:xmlns "http://www.w3.org/2000/svg"
     :fill "none"
     :viewBox "0 0 24 24"}
    [:circle {:class "opacity-25" :cx "12" :cy "12" :r "10" :stroke "currentColor" :strokeWidth "4"}]
    [:path {:class "opacity-75" :fill "currentColor" :d "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"}]]])
